import { isEmpty, flowRight } from 'lodash';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { resolveId } from '@wix/communities-blog-client-common';

import { connect } from '../../../common/components/runtime-context';
import { getIsSeeAllPostsLinkEnabled } from '../../../common/selectors/app-settings-selectors';
import {
  getIsRecentPostsLoaded,
  getIsRelatedPostsLoaded,
} from '../../../common/store/is-loaded/is-loaded-selectors';
import { getRecentPosts } from '../../../common/selectors/recent-posts-selectors';
import AnimatedLoader from '../../../common/components/animated-loader';
import RecentPosts from '../../../recent-posts/components/recent-posts';
import withFeedMetadataSettings from '../../../common/hoc/with-feed-metadata-settings';
import withAuth from '../../../common/hoc/with-auth';
import withDeviceType from '../../../common/hoc/with-device-type';
import withTranslate from '../../../common/hoc/with-translate';
import styles from './post-page.scss';
import { getRelatedPosts } from '../../../common/selectors/related-posts-selectors';
import { getPostListCssVars } from '../../../common/services/post-list-css-vars';

class RelevantPosts extends Component {
  componentDidUpdate = ({
    showRecentPosts: prevShowRecentPosts,
    showRelatedPosts: prevShowRelatedPosts,
  }) => {
    const {
      post,
      fetchRecentPosts,
      fetchRelatedPosts,
      showRecentPosts,
      showRelatedPosts,
    } = this.props;

    if (showRecentPosts && showRecentPosts !== prevShowRecentPosts) {
      fetchRecentPosts(post);
    }

    if (showRelatedPosts && showRelatedPosts !== prevShowRelatedPosts) {
      fetchRelatedPosts(post);
    }
  };

  render = () => {
    const {
      t,
      isRecentPostsLoaded,
      isRelatedPostsLoaded,
      showRecentPosts,
      showRelatedPosts,
      relatedPosts,
      relatedPostsLabelKey,
      recentPosts,
      showAllPostsLink,
    } = this.props;

    if (
      showRelatedPosts ||
      (showRecentPosts && showRelatedPosts === undefined)
    ) {
      const hasRelatedPosts = !isEmpty(relatedPosts);
      return (
        <AnimatedLoader
          isLoading={
            hasRelatedPosts ? !isRelatedPostsLoaded : !isRecentPostsLoaded
          }
        >
          <div className={styles.recentPosts} style={getPostListCssVars()}>
            <RecentPosts
              posts={hasRelatedPosts ? relatedPosts : recentPosts}
              title={t(relatedPostsLabelKey)}
              showAllPostsLink={showAllPostsLink}
            />
          </div>
        </AnimatedLoader>
      );
    }

    return null;
  };
}

RelevantPosts.propTypes = {
  t: PropTypes.func,
  post: PropTypes.object,

  showRelatedPosts: PropTypes.bool,
  relatedPostsLabel: PropTypes.string,
  relatedPostsLabelKey: PropTypes.string.isRequired,

  showRecentPosts: PropTypes.bool,
  isRecentPostsLoaded: PropTypes.bool.isRequired,
  isRelatedPostsLoaded: PropTypes.bool.isRequired,
  fetchRecentPosts: PropTypes.func.isRequired,
  recentPosts: PropTypes.array,

  showAllPostsLink: PropTypes.bool.isRequired,
};

const mapRuntimeToProps = (state, { post }, actions) => {
  const postId = resolveId(post);
  return {
    fetchRecentPosts: actions.fetchRecentPosts,
    recentPosts: getRecentPosts(state, postId),

    fetchRelatedPosts: actions.fetchRecentPosts,
    relatedPosts: getRelatedPosts(state, postId),

    isRecentPostsLoaded: getIsRecentPostsLoaded(state, postId),
    isRelatedPostsLoaded: getIsRelatedPostsLoaded(state, postId),

    showAllPostsLink: getIsSeeAllPostsLinkEnabled(state) !== false,
  };
};

export default flowRight(
  connect(mapRuntimeToProps),
  withFeedMetadataSettings,
  withDeviceType,
  withAuth,
  withTranslate,
)(RelevantPosts);
